import { nodeRestApi } from '../../plugins/api';
import CryptoJS from 'crypto-js';
import router from '../../router';

export default {
  // login
  async login({ commit, state }, payload) {
    commit('setError', false, { root: true });
    try {
      const encryptedpassword = CryptoJS.AES.encrypt(
        payload.password,
        state.aesHexKey
      ).toString();

      const response = await nodeRestApi.post('ecofrost/user/login', {
        email: payload.email,
        password: encryptedpassword
      });

      commit('setUserData', response.data);
      router.push('/');
    } catch (error) {
      if (error.isAxiosError) {
        commit('setError', error.response.data.error.message, { root: true });
      } else {
        commit('setError', error, { root: true });
      }
    }
  },

  async logout({ commit }) {
    commit('clearUserData');
  }
};
